import React, { useContext, useState } from 'react'
import { globalMenuItemData, voiceAgentDeploymentInterface, voiceAgentListInterface } from '../../../models/axiosModel'
import { Grid, Typography } from '@mui/material';
import styles from '../../../assets/styles/componentStyles/voiceAgentStyles/voiceAgent.module.scss'
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { formatDateAccordingToTimezoneUsingMoment, hasVoiceAgentManagePermission } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';
import IconsColor from '../../utility/iconsColor';
import { primaryColor } from '../../../utils/colors';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import globalStyles from '../../../assets/styles/global.module.scss'
import deleteDoc from "../../../assets/deleteDoc.svg"; 
import { useVoiceAgentStore } from '../../../store/voiceAgentStore';
import chipStyle from '../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss'
import GlobalMenu from '../../globalMenu';

interface voiceAgentCardInterface {
    agent: voiceAgentListInterface
}

const VoiceAgentListCard = (props: voiceAgentCardInterface) => {
    const { agent } = props;
    const { userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null);

    const setFlagDeleteAgentPopup = useVoiceAgentStore((state) => state.setFlagDeleteAgentPopup);
    const setDeleteVoiceAgentData = useVoiceAgentStore((state) => state.setDeleteVoiceAgentData);

    const handleViewAgent = () => {
        navigate(`/voiceagent/createvoiceagent?voice_agent_id=${agent.voice_agent_id}`)
    }

    const handleMenuOpen = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const menuItemData: globalMenuItemData[] = [
        {
            type: "item",
            label: "Delete",
            icon: <img alt="" src={deleteDoc} />,
            onClick: (agentData: voiceAgentListInterface) => {
                setFlagDeleteAgentPopup(true);
                setDeleteVoiceAgentData(agentData);
            },
            isDisable: false
        }
    ];

    return (
        <Grid item className={styles.voiceAgentCardStyles} onClick={() => handleViewAgent()}>
            <Grid container gap={"8px"}>
                <Grid item xs={12}>
                    {hasVoiceAgentManagePermission(apiRoutesPermissionAssignment, userDetail) && 
                        <Grid container justifyContent={"space-between"}>
                            <Grid item className={styles.voiceAIIconStyle}>
                                <IconsColor fillColor={primaryColor} iconName="voiceAgent" height="22" width="22"/>
                            </Grid>
                            <Grid item>
                                <MoreVertIcon
                                    className={globalStyles.clickable}
                                    onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {e.stopPropagation(); handleMenuOpen(e)}}
                                /> 
                                <GlobalMenu
                                    anchorEl={anchorEl}
                                    handleMenuClose={handleMenuClose}
                                    menuItemData={menuItemData}
                                    open={Boolean(anchorEl)}
                                    additionalField={agent}
                                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                />
                            </Grid>
                        </Grid>
                    }
                </Grid>
                <Grid item xs={12}>
                    <Typography component='span' className={styles.voiceAgentNameStyle}>{agent.voice_agent_name}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container gap={"2px"}>
                        <Grid item xs={12}>
                            <Typography component='span' className={styles.voiceAgentTimeStyle}>Updated At</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography component='span' className={styles.voiceAgentDescStyle}>{`${formatDateAccordingToTimezoneUsingMoment(agent.timestamp, userDetail?.timezone_hour)}`}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                {/* <Grid item xs={12}>
                    <Typography component='span' className={styles.voiceAgentDescStyle}>{agent.voice_agent_description}</Typography>
                </Grid> */}
                <Grid item xs={12}>
                    <Grid container gap={"6px"}>
                        <Grid item xs={12}>
                            <Typography component='span' className={styles.voiceAgentTimeStyle}>Deployments</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {agent?.voice_agent_deployments?.length > 0 ?
                                <Grid container gap={"8px"}>
                                    {agent?.voice_agent_deployments?.map((agentD: voiceAgentDeploymentInterface) => {
                                        return (
                                            <Grid item className={`${chipStyle.chatbotNameChipNew}`}>
                                                {agentD?.display_phone_number}
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                                :
                                <Grid item>
                                    -
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default VoiceAgentListCard
